import ItineraryPackageLoader, {
    type ItineraryPackageLoaderResult,
} from '../ItineraryPackageLoader';
import type TripPackage from './TripPackage';
import { type TripPackageLoaderConfig } from './types';
import { type Point } from '@itinerary/trip/TripModuleTypes';
import { type FilterData } from '@itinerary/ItineraryModuleTypes';

/**
 * The result from _getPackages method of TripPackageLoader
 */
export interface TripPackageLoaderResult<
    TPackage extends TripPackage = TripPackage,
> extends ItineraryPackageLoaderResult<TPackage> {
    list: TPackage[];
    originLocation: Point | null;
    destinationLocation: Point | null;
    filterMetaData: FilterData;
}

/**
 * The base class for trip package loaders
 */
export default abstract class TripPackageLoader<
    TPackage extends TripPackage = TripPackage,
> extends ItineraryPackageLoader<TPackage> {
    protected _totalSeatCount: number;
    protected _originCode: string;
    protected _destinationCode: string;
    protected _originName?: string;
    protected _destinationName?: string;
    private readonly _date: Date;
    constructor({
        totalSeatCount,
        url,
        originCode,
        destinationCode,
        originName,
        destinationName,
        date,
    }: TripPackageLoaderConfig) {
        super({ url });
        this._totalSeatCount = totalSeatCount;
        this._originCode = originCode;
        this._destinationCode = destinationCode;
        this._originName = originName;
        this._destinationName = destinationName;
        this._date = date;
    }

    get originCode() {
        return this._originCode;
    }

    get originName() {
        return this._originName;
    }

    get destinationCode() {
        return this._destinationCode;
    }

    get destinationName() {
        return this._destinationName;
    }

    override get date(): Date {
        return this._date;
    }

    abstract override _getPackages(
        axiosParams?: any
    ): AsyncGenerator<TripPackageLoaderResult<TPackage>>;
}
